import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsSttsItem from "./SetsSttsItem"
import { CompactPicker } from 'react-color'
import SettingsForm from './SettingsForm'

class SetsStts extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('stts');
    this.setState({
      adding: false,
      colorPick: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'stts'

  newItem = {
    stts_desc: '',
    stts_color_id: '#ffffff',
    stts_active: 1,
    stts_locked: 0,
    stts_rep: 1
  };

  selectColor = () => {
    this.setState({colorPick:true});
  }

  applyColor = color => {
    this.setState({
      data:{
        ...this.state.data,
        stts_color_id:color.hex
      },
      colorPick:false
    });
  }

  render() {
    if(isEmpty(this.props.sttss.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const sttss = this.props.sttss.data;
    const { search, sort } = this.props.sttss;
    const { data, errors } = this.state;

    var fltrSttss = [];
    for(var key in sttss){
      if(sttss.hasOwnProperty(key)){
        const active = sttss[key].stts_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + sttss[key].stts_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrSttss.push(sttss[key]);
        }
      }
    }

    const srtSttss = fltrSttss.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.stts_id < b.stts_id)
         return sort.asc ? -1 : 1
      if(a.stts_id > b.stts_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedSttss = srtSttss ? srtSttss.map(stts =>
      <SetsSttsItem key={stts.stts_id}
        data={stts}
      />
    ) : [];

    const clearSearchBtn = <button
        type="button"
        className="btn btn-default"
        onClick={this.clearSearch}
        title="Очистить поиск">
        X
      </button>;
    const colorPick = this.state.colorPick ?
      <div style={{position:'absolute',zIndex:2,right:'15px'}}>
        <CompactPicker
          color={data.stts_color_id}
          onChangeComplete={ this.applyColor }
        />
      </div>
      :'';

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.stts_desc}
              name="stts_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <input
            type="checkbox"
            checked={data.stts_rep}
            name="stts_rep"
            onChange={this.handleChBox}
          />
        </td>
        <td>
          <input
            type="checkbox"
            checked={data.stts_locked}
            name="stts_locked"
            onChange={this.handleChBox}
          />
        </td>
        <td
          style={{
            backgroundColor:data.stts_color_id,
            cursor:'pointer'
          }}
          onClick={this.selectColor}
        >
          {colorPick}
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка статусов заказа</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              {clearSearchBtn}
            </div>
          </div>{" "}
          <div className="input-group">{fltrSttss.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-7" onClick={() => {this.handleSort('stts_desc')}}>Краткое название</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('stts_rep')}}>Учитывать в отчетах</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('stts_locked')}}>Закрыть доступ</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('stts_color_id')}}>Цвет</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedSttss}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    sttss: store.sttss
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsStts);



// WEBPACK FOOTER //
// ./src/components/settings/SetsStts.js